import { z } from 'zod/v3';

export const zDataType = z.enum(['DATE', 'NUMBER', 'TEXT']);
